import { APEX25_LEGAL_PAGES } from "../industries";
import candidateTermsRaw from "./docs/candidate-terms.md?raw";
import privacyRaw from "./docs/privacy.md?raw";
import termsRaw from "./docs/terms.md?raw";
import trialTermsRaw from "./docs/trial-terms.md?raw";
import { type LegalDoc, parseLegalDoc } from "./parse";

export const APEX25_LEGAL_HUB_PATH = "/legal";

/** Who a document is for, which is how the hub groups them. Listed in display order. */
export const APEX25_LEGAL_AUDIENCES = ["customer", "candidate", "everyone", "demo"] as const;
export type Apex25LegalAudience = (typeof APEX25_LEGAL_AUDIENCES)[number];

export const APEX25_LEGAL_DOCS: Record<string, { audience: Apex25LegalAudience; doc: LegalDoc }> =
  {
    "/terms": { audience: "customer", doc: parseLegalDoc(termsRaw) },
    "/candidate-terms": { audience: "candidate", doc: parseLegalDoc(candidateTermsRaw) },
    "/privacy": { audience: "everyone", doc: parseLegalDoc(privacyRaw) },
    // PLACEHOLDER: facts about the public demo only, until real trial terms are written.
    "/trial-terms": { audience: "demo", doc: parseLegalDoc(trialTermsRaw) },
  };

export const isLegalDocPath = (path: string) => path in APEX25_LEGAL_DOCS;

export const legalDescription = (path: string) => APEX25_LEGAL_PAGES[path]?.description ?? "";
